<template>
<el-row>




    <el-dialog title="官网直购入口" width="90%" style="" :visible.sync="mobile_product_visible">
        <div style="width:100%;text-align:left;font-size:15;">
            <div>“微易用题库” 微信小程序，软件试用期到了之后可以使用微信支付直接购买，也可使用 “支付宝“ 进行支付购买</div>
            
            <div style="margin-top:30px;">使用支付宝支付注意事项：</div>

            <div>1.请根据下方选择欲购买的品类，可使用支付宝进行支付</div>
            <div style="margin-top:10px;">2.购买时需要登录的账号，<b style="color:red;">必须为跟小程序同一手机号</b></div>

            <div style="margin-top:30px;">产品选择：</div>
            <a style="color:#666;text-decoration: none;margin:8px;" href="https://m.weyiyong.com/mobile/product_service/detail_page?pid=5"><div style="padding:4px;border:1px solid #eee;">2021健康管理师AI督学班</div></a>
            <a style="color:#666;text-decoration: none;margin:8px;" href="https://m.weyiyong.com/mobile/product_service/detail_page?pid=6"><div style="padding:4px;border:1px solid #eee;">2021护士资格AI督学班</div></a>
            <a style="color:#666;text-decoration: none;margin:8px;" href="https://m.weyiyong.com/mobile/product_service/detail_page?pid=7"><div style="padding:4px;border:1px solid #eee;">2021初级护师AI督学班</div></a>
            <a style="color:#666;text-decoration: none;margin:8px;" href="https://m.weyiyong.com/mobile/product_service/detail_page?pid=8"><div style="padding:4px;border:1px solid #eee;">2021主管护师AI督学班</div></a>


            <div style="margin-top:10px;">
                以上产品<b>同</b>微信小程序 “微易用题库” 内产品，如果在购买、使用过程中遇到什么问题，均可联系客服（见底部）</div>

        </div>
    </el-dialog>






    <el-dialog title="微信扫码联系客服" width="90%" style="" :visible.sync="mobile_cs_visible">
        <div style="width:100%;text-align:center;">

            <div>
                <img style="width:90%;" src="../assets/contact_qrcode2.jpg" />
            </div>
        </div>
    </el-dialog>

    <el-dialog title="微信扫码联系客服" width="30%" style="" :visible.sync="pc_cs_visible">
        <div style="width:100%;text-align:center;">

            <div>
                <img style="width:90%;" src="../assets/contact_qrcode2.jpg" />
            </div>
        </div>
    </el-dialog>

    <!--mobile start-->

    <el-col :span="24" class="hidden-sm-and-up">
        <el-menu style="z-index:999;position:fixed;top:0;left:0;right:0;display:flex;justify-content: flex-end;border: 0;" :default-active="default_menu_idx" class="el-menu-demo" mode="horizontal" @select="handleMenuMobile" background-color="#1874db" text-color="#fff" active-text-color="#fff">
            <div style="align-self:center;">
                <img src="../assets/logo.png" style="item;height:50px;" />
            </div>
            <div style="flex-grow:1"></div>

<!--
            <el-menu-item index="4">
                <span slot="title">购买产品</span>
            </el-menu-item>
-->

<!--
            <el-menu-item index="1">
                <span slot="title">联系客服</span>
            </el-menu-item>
-->
            <el-menu-item index="3">
                <icon class="title" name="app" scale="2.3" style="color:#fff"></icon>
                <span slot="title">APP下载</span>
            </el-menu-item>
        </el-menu>

        <div class="bg1" style="display:block;height:100%; padding-top:100px;">
            <div style="width:100%;">
                <img src="../assets/example.png" style="width:90%;" />
            </div>

            <div style="padding:30px;font-size:14px;">
                <h1 style="font-weight: 500;">微易用题库-考试利器</h1>
                <div>多品类，多学科题库，多种学习模式，免费，绿色</div>

            </div>
        </div>

        <div class="bg2" style="flex-direction:column;padding-top:30px;height:100%;">

            <div style="text-align:center;color:#666;margin-bottom:40px;font-size:20px;font-weight:600;">
                题库合作
            </div>

            <div style="display:flex;flex-direction: column;">

                <div style="width:100%;height:100%;text-align:center;">
                    <div style="display:flex;flex-direction: column;padding:40px;">
                        <icon name="agent" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        题库销售代理
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            网店、实体店、个人媒体、机构媒体等均可作为销售代理终端，合作方式多样，请加下方微信详谈
                        </div>
                    </div>
                </div>

                <div style="width:100%;height:100%;text-align:center;">
                    <div style="display:flex;flex-direction: column;padding:40px;">
                        <icon name="doc" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        内容合作
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            欢迎各机构，个人进行内容的合作，包括并不限于考题，视频等相关学习资料，请加下方微信详谈
                        </div>
                    </div>
                </div>

                <div style="width:100%;height:100%;text-align:center;">
                    <div style="display:flex;flex-direction: column;padding:40px;">
                        <icon name="dev" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        培训机构题库定制
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            团队拥有10年以上丰富的开发经验，可为培训机构定制自己的学习平台，请加下方微信详谈
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="bg2 bgc" style="height:200px;padding-left:10px;padding-right:10px;padding-top:20px;padding-bottom:20px;flex-direction:column;background-color:#1874db;color:#fff;">

            <div style="margin-bottom:20px;flex-direction:row;">
                <div style="display:inline-block;">
                    <img src="../assets/contact_qrcode2.jpg" style="width:100px;height:100px;" />
                </div>

                <div style="float:right;text-align:left;font-size:13px;">
                    <div style="padding-bottom:20px;">商务合作：</div>
                    <div style="margin-bottom:20px;"><a :href="'tel:010'+tel_num" style="color:white;text-decoration:none;">电话：010-{{tel_num}}</a></div>
                    <div style="">客服微信：请扫左侧二维码</div>
                </div>

            </div>

            <div style="font-size:13px;color:#ddd;width:100%;text-align:center;">

                版权所有 微易用科技 ©2020-今 <br />
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010918" style="text-decoration: none;color:#ddd;"><img src="../assets/gongan.png" style="width:15px;margin-right:4px;" />京公网安备 11011402010918号</a>
                <br />
                <a style="text-decoration: none;color:#ddd;" href="http://beian.miit.gov.cn/" target="_blank">京ICP备2020036784号</a>
            </div>
        </div>

    </el-col>

    <!--pc start-->

    <el-col :span="24" class="hidden-xs-only">

        <el-menu style="display:flex;justify-content: flex-end;border: 0;" :default-active="default_menu_idx" class="el-menu-demo" mode="horizontal" @select="handleMenuPC" background-color="#1874db" text-color="#fff" active-text-color="#fff">
            <div style="margin-left:10px;align-self:center;">
                <img src="../assets/logo.png" style="item;height:55px;" />
            </div>
            <div style="flex-grow:1"></div>


<!--
            <el-menu-item index="4">
                <span slot="title">购买产品</span>
            </el-menu-item>
-->

<!--
            <el-menu-item index="1">
                <span slot="title">联系客服</span>
            </el-menu-item>
-->

            <el-menu-item index="3">
                <icon class="title" name="app" scale="2.3" style="color:#fff"></icon>
                <span slot="title">APP下载</span>
            </el-menu-item>

        </el-menu>

        <div class="bg1" style="min-width:1000px;">
            <div style="height:100%;">
                <img src="../assets/example.png" style="width:550px;" />
            </div>

            <div style="width: 450px;margin-left: 90px;height:100%;">
                <h1 style="font-weight: 500;margin-top:0;">微易用题库-考试利器</h1>
                <h3 style="font-weight: 200;">多品类，多学科题库，多种学习模式，免费，绿色</h3>
            </div>
        </div>

        <div class="bg2" style="flex-direction: column;padding-top:0px;">

            <div style="text-align:center;color:#666;margin-bottom:40px;font-size:30px;font-weight:600;">
                题库合作
            </div>

            <div style="display:flex;flex-direction: row;">

                <div style="width:33%;height:100%;text-align:center;flex-grow:1;margin:40px;">
                    <div style="display:flex;flex-direction: column;">
                        <icon name="agent" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        题库销售代理
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            网店、实体店、个人媒体、机构媒体等均可作为销售代理终端，合作方式多样，请加下方微信详谈
                        </div>
                    </div>
                </div>

                <div style="width:33%;height:100%;text-align:center;flex-grow:1;margin:40px;">
                    <div style="display:flex;flex-direction: column;">
                        <icon name="doc" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        内容合作
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            欢迎各机构，个人进行内容的合作，包括并不限于考题，视频等相关学习资料，请加下方微信详谈
                        </div>
                    </div>
                </div>

                <div style="width:33%;height:100%;text-align:center;flex-grow:1;margin:40px;">
                    <div style="display:flex;flex-direction: column;">
                        <icon name="dev" scale="8" style="color:#3ea3ff;align-self: center;"></icon>
                        培训机构题库定制
                        <div style="text-align:left;color:#888;margin-top:15px;font-size:16px;">
                            团队拥有10年以上丰富的开发经验，可为培训机构定制自己的学习平台，请加下方微信详谈
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="bg2 bgc" style="height:290px;padding-top:20px;flex-direction:column;background-color:#1874db;color:#fff;">
            <div style="padding-left:40px;padding-right:40px;margin-bottom:20px;flex-direction:row;">

                <div style="display:inline-block;height:105px;">
                    <img src="../assets/logo.png" style="height:55px;" />
                    <el-card shadow="always" style="max-width:500px;">
                        <img src="../assets/contact_qrcode2.jpg" style="width:60px;height:60px;margin-right:10px;" />
                        题库使用问题请加客服微信了解
                    </el-card>
                </div>

                <div style="float:right;height:105px;padding:30px;padding-top:60px;font-size:14px;text-align:right;">
                    <div style="margin-bottom:10px;"><a :href="'tel:010'+tel_num" style="color:white;text-decoration:none;">商务合作：010-{{tel_num}}</a></div>
                    <div style="">客服微信：请扫左侧二维码</div>
                </div>

            </div>

            <div style="font-size:13px;color:#ddd;width:100%;text-align:center;margin-bottom:10px;">

                版权所有 微易用科技 ©2020-今
                <br />
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010918" style="text-decoration: none;color:#ddd;"><img src="../assets/gongan.png" style="width:15px;margin-right:4px;" />京公网安备 11011402010918号</a>
                <a style="text-decoration: none;color:#ddd;" href="http://beian.miit.gov.cn/" target="_blank">京ICP备2020036784号</a>
            </div>
        </div>

    </el-col>

</el-row>
</template>

<script>
export default {
    name: 'index',
    computed:{
        tel_num(){
            let n = ['2','9','4','4','4','3','8','5']
            return n[7]+n[6]+n[5]+n[4]+n[3]+n[2]+n[1]+n[0];
        }
    },
    data() {
        return {
            mobile_product_visible:false,
            mobile_cs_visible: false,
            pc_cs_visible: false,
            default_menu_idx: '3'
        }
    },
    methods: {

        handleMenuMobile(val) {
            this.$nextTick(() => {
                this.default_menu_idx = '1'
                console.log('mobile', val)
                if (val == 1) {
                    this.mobile_cs_visible = true
                } else if (val == 3) {
                    location.href = 'https://m.weyiyong.com/app/?from=site'
                }else if (val==4){
                    this.mobile_product_visible = true
                }

            })
        },
        handleMenuPC(val) {
            this.$nextTick(() => {
                this.default_menu_idx = '1'
                console.log('pc', val)
                if (val == 1) {
                    this.pc_cs_visible = true
                } else if (val == 3) {
                    location.href = 'https://m.weyiyong.com/app/?from=site'
                }else if (val==4){
                    this.mobile_product_visible = true
                }

            })
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.bg1 {
    padding-top: 100px;
    padding-bottom: 100px;
    height: 468px;
    position: relative;
    overflow: hidden;
    background: transparent url(../assets/bg.jpg) no-repeat center top;
    background-size: cover;
    -webkit-background-size: cover;
    color: #fff;
    justify-content: center;
    display: flex;

}

.bg2 {
    padding-top: 150px;
    height: 468px;
    position: relative;
    overflow: hidden;
    justify-content: center;
    display: flex;
}

.bgc {
    background: #f9f9f9;
}

.el-menu--horizontal>.el-menu-item {
    border-bottom: none;
    text-align: center;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
}
</style>
